<template>
  <v-card>
    <div>
      <div style="display: flex; justify-content: space-between">
        <div style="align-self: center; font-size: 23px; font-weight: 600" class="pl-3">
          {{ edittype == 'create' ? 'Add Project' : 'Edit Project' }}
        </div>
        <div>
          <v-btn @click="$emit('close')" style="float: right" icon><v-icon>close</v-icon></v-btn>
        </div>
      </div>
      <v-divider></v-divider>
    </div>
    <div class="pa-2">
      <div class="pa-3">
        <v-layout row wrap>
          <v-flex xs12>
            <div>Project name</div>
            <div>
              <v-select
                :disabled="edittype == 'edit'"
                v-model="input.project_name"
                :items="projectOptions"
                outline
                name="Project name"
                single-line
                v-validate="'required'"
                :data-vv-as="$t('Project name')"
              ></v-select>
              <p
                class="text-error form-control"
                :class="{ 'has-error': errors.has('Project name') }"
                v-if="errors.has('Project name')"
              >
                {{ errors.first('Project name') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs6>
            <div>Floor</div>
            <div class="form-control" :class="{ 'has-error': errors.has('Floor') }">
              <input
                :data-vv-as="$t('Floor')"
                name="Floor"
                v-validate="'required'"
                type="text"
                v-model="input.floor"
              />
              <p class="text-error" v-if="errors.has('Floor')">
                {{ errors.first('Floor') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs6 class="pl-2">
            <div>Unit no</div>
            <div class="form-control" :class="{ 'has-error': errors.has('unit_no') }">
              <input
                :data-vv-as="$t('Unit no')"
                name="unit_no"
                v-validate="'required'"
                type="text"
                v-model="input.unit_no"
              />
              <p class="text-error" v-if="errors.has('unit_no')">
                {{ errors.first('unit_no') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs6>
            <div>Area</div>
            <div class="form-control" :class="{ 'has-error': errors.has('Area') }">
              <input
                :data-vv-as="$t('Area')"
                type="text"
                name="Area"
                v-validate="'required|decimal:2'"
                v-model="input.area"
              />
              <p class="text-error" v-if="errors.has('Area')">
                {{ errors.first('Area') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs6 class="pl-2">
            <div>Point</div>
            <div class="form-control" :class="{ 'has-error': errors.has('point') }">
              <input
                :data-vv-as="$t('Points')"
                name="point"
                v-validate="'required|numeric'"
                type="number"
                v-model="input.point"
              />
              <p class="text-error" v-if="errors.has('point')">
                {{ errors.first('point') }}
              </p>
            </div>
          </v-flex>
          <!-- <v-flex xs6>
            <div>Group</div>
            <div class="form-control" :class="{ 'has-error': errors.has('group') }">
              <input
                :data-vv-as="$t('Group')"
                name="group"
                v-validate="'required'"
                type="text"
                v-model="input.group"
              />
              <p class="text-error" v-if="errors.has('group')">
                {{ errors.first('group') }}
              </p>
            </div>
          </v-flex>
          <v-flex xs6 class="pl-2">
            <div>Line id</div>
            <div class="form-control" :class="{ 'has-error': errors.has('lineid') }">
              <input
                :data-vv-as="$t('Line id')"
                name="lineid"
                v-validate="'required'"
                type="text"
                v-model="input.lineid"
              />
              <p class="text-error" v-if="errors.has('lineid')">
                {{ errors.first('lineid') }}
              </p>
            </div>
          </v-flex> -->
        </v-layout>
      </div>
      <div class="text-xs-center">
        <v-btn @click="$emit('close')" color="grey" outline> {{ $t('cancel') }}</v-btn>
        <v-btn :loading="loading" @click="saveData" color="primary" depressed>
          {{ $t('Save') }}</v-btn
        >
      </div>
    </div>
  </v-card>
</template>

<script>
import uploadfile from '@/components/elements/uploadfile.vue'
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  components: {
    uploadfile
  },
  props: ['editdata', 'edittype', 'account_no'],
  computed: {
    ...mapGetters(['selectedBot'])
  },
  data() {
    return {
      projectOptions: [
        { text: 'MUNIQ Sukhumvit 23 | มิวนีค สุขุมวิท 23', value: 'MUNIQ Sukhumvit 23' },
        { text: 'MARU LADPRAO 15 | มารุ ลาดพร้าว 15', value: 'MARU Ladprao 15' },
        // { text: 'MARU LADPRAO 16 | มารุ ลาดพร้าว 16', value: 'MARU Ladprao 16' },
        // { text: 'MARU LADPRAO 17 | มารุ ลาดพร้าว 17', value: 'MARU Ladprao 17' },
        // { text: 'MARU LADPRAO 18 | มารุ ลาดพร้าว 18', value: 'MARU Ladprao 18' },
        // { text: 'MARU LADPRAO 19 | มารุ ลาดพร้าว 19', value: 'MARU Ladprao 19' },
        { text: 'MARU EKKAMAI 2 | มารุ เอกมัย 2', value: 'MARU Ekkamai 2' },
        { text: 'MUNIQ LANGSUAN | มิวนีค หลังสวน', value: 'MUNIQ Langsuan' }
      ],
      input: {
        project_name: '',
        floor: '',
        unit_no: '',
        area: '',
        point: '',
        group: '',
        lineid: ''
      },
      loading: false
    }
  },
  created() {
    if (this.edittype == 'edit') {
      this.input = { ...this.editdata }
    }
  },
  methods: {
    async saveData() {
      var vm = this
      if (await this.$validator.validate()) {
        var data = {
          pageid: this.selectedBot.pageid,
          account_no: this.account_no,
          ...this.input
        }
        this.loading = true
        if (this.edittype == 'create') {
          api.postmjdaddcustomerprojectByadmin(data, async (err, response) => {
            if (err) {
            } else if (response.responsecode == 200) {
              await vm.$swal.fire({
                type: 'success',
                text: 'สำเร็จ'
              })
              vm.$emit('oncreate', response.data[0])
            }
            vm.loading = false
          })
        } else {
          api.putmjdcustomerprojectdashboard(
            { ...data, project_id: this.editdata.id },
            async (err, response) => {
              if (err) {
              } else if (response.responsecode == 200) {
                await vm.$swal.fire({
                  type: 'success',
                  text: 'สำเร็จ'
                })
                vm.$emit('onedit', { ...data, id: vm.editdata.id })
              }
              vm.loading = false
            }
          )
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/mjd/PersonalProjectEdit.vue